import script from "./SelectionPrestation.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectionPrestation.vue?vue&type=script&setup=true&lang=js"

import "./SelectionPrestation.vue?vue&type=style&index=0&id=1a557738&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a557738"]])

export default __exports__